import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { CreativeContextSelection } from "@digital-twins/shared-types";
import { knowledgeThreadsApi } from "@/lib/api";
import { creativeLibraryApi } from "@/lib/api/creative-library";
import { ROUTES } from "@/routes/routes";

export function useStartCreativeThread() {
  const navigate = useNavigate();
  const [starting, setStarting] = useState<string | null>(null);
  const [actionError, setActionError] = useState(false);
  async function start(token: string, selection: CreativeContextSelection) {
    setStarting(token);
    setActionError(false);
    try {
      const thread = await knowledgeThreadsApi.create({});
      const state = await creativeLibraryApi.context(thread.token);
      await creativeLibraryApi.updateContext(
        thread.token,
        state.revision,
        selection,
      );
      navigate(ROUTES.thread(thread.token));
    } catch {
      setActionError(true);
    } finally {
      setStarting(null);
    }
  }
  return {
    start,
    starting,
    actionError,
    clearActionError: () => setActionError(false),
  };
}
